var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"messageContainer",staticClass:"message-container"},[_c('MessageArea',{attrs:{"title":"留言板","subTitle":`(${_vm.data.total})`,"isListLoading":_vm.isLoading,"list":_vm.data.rows},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }